import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../_services/auth.service";

import { ConfirmationService, SelectItem } from "primeng/api";
import { StoreInfo } from "src/domain/storeInfo";
import { TranslateService } from "@ngx-translate/core";
import { LocaleService } from "src/app/_services/locale.service";
import { SettingsService } from "src/app/_services/settings.service";
import { GlobalService } from "src/app/_services/global.service";
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { CookieService } from "src/app/_services/cookie.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [ConfirmationService],
})
export class LoginComponent implements OnInit {
  version: any = environment.VERSION_NUMBER;
  commitVersion: any = environment.COMMIT_VERSION_NUMBER;
  buildDate: Date = environment.VERSION_DATE;
  showPasswordDimenticata:boolean=false;
  userPassowrdDimenticata='';
  loginModel: LoginModel = {} as LoginModel;
  loginParams: any = {};
  storeInfo: StoreInfo;
  societaLicenza: string;

  showCompanyDropdown = true;

  username: string;
  password: string;

  workstations: SelectItem[];
  companies: SelectItem[];
  shops: SelectItem[];

  noWorkstation: boolean = false;
  workstation: any;
  company: any;
  shop: any;

  showSpinner: boolean;
  msgs: any;

  loginStep: string; // can be 'login', 'postazione', 'negozio'

  whatsNewDialog: boolean = false;
  newVersion: boolean = false;
  newVersionRead: boolean = false;

  loginAttempt: boolean = false;

  // showConcurrentUserDialog: boolean = false;

  //loginSucceded = false;
  features:any[]=[];

  constructor(
    private authService: AuthService,
    private router: Router,
    private session: LocaleService,
    private translate: TranslateService,
    private settingsService: SettingsService,
    private globalService: GlobalService,
    private confirmationService: ConfirmationService,
    private http: HttpClient,
    public cookie: CookieService
  ) {}

  ngOnInit() {



    this.showSpinner = false;
    this.msgs = [];
    if (localStorage.getItem("logInfo")) {
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      this.loginModel.saveUsernameCustomer=logInfo.saveUsernameCustomer;
      if(logInfo.saveUsernameCustomer){
        this.loginModel.username = logInfo.username;
      } else {
        this.loginModel.username = "";
      }
      this.loginModel.password = "";
    } else {
      this.loginModel.username = "";
      this.loginModel.password = "";
    }
    this.loginStep = "login";
    /*
    if (this.authService.loggedIn) {
      this.router.navigateByUrl("/dashboard");
    }
    */
    
    // Controllo se l'utente è già loggato e se è l'utente 'reactivesrl'
    if (this.authService.loggedIn) {
      const logInfoStr = localStorage.getItem("logInfo");
      let savedUser = '';
      
      if (logInfoStr) {
        const logInfo = JSON.parse(logInfoStr);
        savedUser = logInfo.username;
      }

      if (savedUser === 'reactivesrl') {
        this.router.navigateByUrl("/dashboard");
      } else {
        window.location.href = '/HOMEPAGE/index.php';
      }
    }

    this.useLocale();
    this.manageNewVersion();
    this.http.get<any>('./assets/features/features.json').subscribe((res)=>{

      this.features= res;
    });

  }

  manageNewVersion() {
    

    if (localStorage.getItem("version")) {
      let savedVersion = localStorage.getItem("version");

      if (savedVersion !== environment.VERSION_NUMBER) {
        this.newVersionRead = false;

        localStorage.setItem("version", environment.VERSION_NUMBER);
        localStorage.setItem("newVersionRead", JSON.stringify(false));
      }
    } else {
      this.newVersionRead = false;

      localStorage.setItem("version", environment.VERSION_NUMBER);
      localStorage.setItem("newVersionRead", JSON.stringify(false));
    }

    if (localStorage.getItem("newVersionRead")) {

      this.newVersionRead = JSON.parse(localStorage.getItem("newVersionRead"));
    }
  }

  openVersionDialog(isNew: boolean) {
    if (isNew) {
      this.whatsNewDialog = true;
      this.newVersionRead = true;
      localStorage.setItem("newVersionRead", JSON.stringify(true));
    } else {
      this.whatsNewDialog = true;
    }
  }

  /**
   * Effettua il login 
   */
  login() {
    this.loginAttempt = true;

    this.loginParams.username = this.loginModel.username.trim();
    this.loginParams.password = this.loginModel.password;
    
    
    let saveLogin = {
        username: this.loginModel.username.trim(),
        password:this.loginParams.password,
        saveUsernameCustomer:this.loginModel.saveUsernameCustomer
      };
    localStorage.setItem("logInfo", JSON.stringify(saveLogin));
   
    this.showSpinner = true;
   
    this.authService.loginError='';
    this.msgs = [];
    
   

    this.authService.login(this.loginParams).subscribe(
      (data) => {
        this.authService.loginError='';
        this.msgs = [];
        this.authService.logininfo(this.globalService.loggedUser.id).subscribe((datali) => {
          let li= JSON.stringify(datali.Result);
          localStorage.setItem("logininfo", li);
          this.globalService.logininfo=datali.Result;
         
          this.authService.gestisciAbilitazioni();
          
          /*
          if(sessionStorage.getItem('redirect')){
            const cu=sessionStorage.getItem('redirect');
            sessionStorage.removeItem('redirect');
            window.location.href=cu;
          } else {
            window.location.reload();
          }
          */

          // Mi assicuro che il PHP riceva i dati dell'utente
          localStorage.setItem("loggedUser", JSON.stringify(this.globalService.loggedUser));

          if(sessionStorage.getItem('redirect')){
            const cu=sessionStorage.getItem('redirect');
            sessionStorage.removeItem('redirect');
            window.location.href=cu;
          } else {
            if (this.loginParams.username === 'reactivesrl') {
              this.authService.gestisciAbilitazioni();
              this.router.navigateByUrl("/dashboard");
            } else {
              window.location.href = '/HOMEPAGE/index.php';
            }
          }
          
        //this.authService.gestisciAbilitazioni();
        //this.router.navigateByUrl("/dashboard");

       //  window.location.reload();
        });
       
      },
      (error) => {
        console.error('error',error);
        this.showSpinner = false;
        this.loginAttempt = false;
        this.msgs = [];
        if (
          error.error.ExceptionMessage &&
          error.error.ExceptionMessage.includes("database slave")
        ) {
          this.msgs.push({
            severity: "error",
            detail: "Verificare correttezza di nome utente o password",
          });
        } else if (error.error.ExceptionMessage) {
          this.msgs.push({
            severity: "error",
            detail: error.error.ExceptionMessage,
          });
        } else {
          this.msgs.push({
            severity: "error",
            detail:
              "Errore imprevisto. Si prega di riprovare più tardi. Se il problema persiste, si prega di contattare il supporto tecnico.",
          });
        }
      }
    );
  }

  
  public canProceed(): boolean {
    // se c'è la postazione selezionata, o è stato selezionato il flag "noWorkstation", allora si può procedere
    if (this.workstation || this.noWorkstation) {
      return true;
    }
    return false;
  }

  
  /**
   * @deprecated
   */
  fillCompanyDropdown(storeInfo: StoreInfo) {
    let companies: SelectItem[];
    companies = [
      { label: this.translate.instant("login.selectCompany"), value: null },
    ];
    let companiesMap: Map<string, string> = new Map<string, string>();
    for (let company of storeInfo.ListaSocieta) {
      company = company.trim().toUpperCase();
      companiesMap.set(company, company);
    }
    companiesMap.forEach((value: string, key: string) => {
      companies.push({ label: key, value: value });
    });
    this.companies = companies;
  }


  loggedIn() {
    const token = localStorage.getItem("token");
    return !!token;
  }

  logout() {
    localStorage.removeItem("token");
  }

  
  resetPassword(){
    
    this.authService.resetPasswordPrimaria({method :'reset',user:this.userPassowrdDimenticata}).subscribe( data=> {
   
      this.globalService.changePasswordMessage.push(
        {severity: 'success', detail: 'Email inviata con successo'
      });
     
    }, error => {
      console.error('error',error);
      this.msgs.push({severity: 'error', detail: 'Utente non trovato'});
    
    });

  }

  useLocale() {
    if (this.globalService.decimalSeparator) {
      this.session.registerCulture(this.globalService.decimalSeparator);
    } else {
      this.session.registerCulture("it");
    }
  }

  backToLogin() {
    this.loginStep = "login";
    this.authService.logout();
  }

  

  

  private getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //Il max è escluso e il min è incluso
  }
}

export interface LoginModel {
  username: string;
  customer: string;
  saveUsernameCustomer: boolean;
  password: string;
}
